// Custom filter method for Yes/No filtering
const yesNoFilterMethod = (filter, row) => {
    const { value } = filter;
    if (!value) return true;

    const cellValue = row[filter.id];
    
    if (value === "true") {
        return cellValue === true;
    } else if (value === "false") {
        return cellValue === false;
    }
    
    return true;
};

export default yesNoFilterMethod;
